<template>
    <div>
        <!--                <notifications group="app"></notifications>-->
        <notifications group="app" position="top right">
            <template slot="body" slot-scope="props">
                <div
                    class="display-flex px-10 py-8 notice"
                    :style="{
                        background: getNoticeColor(props.item.type).bg,
                        border: `0.16rem solid ${getNoticeColor(props.item.type).border}`,
                        color: getNoticeColor(props.item.type).color,
                        borderRadius: '6px'
                    }"
                >
                   <div style="width: 22px">
                       <img :src="`/img/notification/${props.item.type}.svg`" alt="icon-toast" style="width: 20px; margin-top: 2px">
                   </div>
                    <div class="px-2" style="flex: 1">
                        <div style="font-family: 'open sans semi'; font-size: 15px">{{ props.item.title }}</div>
                        <div class="notice-content">{{ $utils.limitStringLength(props.item.text, 200) }}</div>
                    </div>
                    <div style="width: 22px">
                        <v-icon style="font-size: 22px" :color="getNoticeColor(props.item.type).border" @click="props.close">mdi-close</v-icon>
                    </div>
                </div>
            </template>
        </notifications>
        <Inform ref="Inform"></Inform>
        <Confirm ref="Confirm"></Confirm>
        <InputTextDialog ref="InputTextDialog"></InputTextDialog>
        <TextEditor ref="TextEditor"></TextEditor>
    </div>
</template>

<script>
import Confirm from '@/modules/fptai/components/Confirm'
import Inform from '@/components/dialog/Inform'
import InputTextDialog from '@/components/InputTextDialog'
import {AppServiceEventBus, AppServiceEventBusType} from '@/eventbus/appservice.eventbus'
import TextEditor from "@/components/TextEditor";

export default {
    name: 'AppServiceView',
    components: {
        TextEditor,
        InputTextDialog,
        Confirm,
        Inform
    },
    data() {
        return {}
    },
    mounted() {
        AppServiceEventBus.$on(AppServiceEventBusType.INFORM, ({message, options}) => {
            this.$refs.Inform.open(message, options)
        })
        AppServiceEventBus.$on(AppServiceEventBusType.CLOSE_INFORM, () => {
            this.$refs.Inform.close()
        })
        AppServiceEventBus.$on(AppServiceEventBusType.TOAST, options => {
            this.$notify(options)
        })
        AppServiceEventBus.$on(AppServiceEventBusType.CONFIRM, ({message, notice}) => {
            this.$refs.Confirm.open(message, notice).then(
                result => AppServiceEventBus.$emit(AppServiceEventBusType.CONFIRM_DONE, result)
            )
        })
        AppServiceEventBus.$on(AppServiceEventBusType.INPUT_TEXT, title => {
            this.$refs.InputTextDialog.open(title).then(
                result => AppServiceEventBus.$emit(AppServiceEventBusType.CONFIRM_DONE, result)
            )
        })
        AppServiceEventBus.$on(AppServiceEventBusType.TEXT_EDITOR, data => {
            this.$refs.TextEditor.open(data).then(
                result => AppServiceEventBus.$emit(AppServiceEventBusType.TEXT_EDITOR_DONE, result)
            )
        })
    },
    methods: {
        getNoticeColor(type) {
            let colorObj = {
                bg: '#090e24',
                border: '#090e24',
                color: '#FFFFFF'
            }
            switch (type) {
                case 'success':
                    colorObj.bg = '#f1faf7'
                    colorObj.border = '#32c48d'
                    colorObj.color = '#02543e'
                    break
                case 'error':
                    colorObj.bg = '#fff0f0'
                    colorObj.border = '#e53d3f'
                    colorObj.color = '#e53d3f'
                    break
                case 'info':
                    colorObj.bg = '#ebf5ff'
                    colorObj.border = '#76a9fa'
                    colorObj.color = '#0052CC'
                    break
                case 'warning':
                    colorObj.bg = '#fefdeb'
                    colorObj.border = '#e3a008'
                    colorObj.color = '#8d4b0f'
                    break
            }
            return colorObj
        }
    }
}
</script>

<style lang="scss">
.notifications {
    top: 70px !important;
    right: 16px !important;
    max-width: 380px !important;
    width: 330px !important;
}

.vue-notification {
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
    border-radius: 3px;
}

.vue-notification-group {
    top: 64px !important;
}

.notification-wrapper:not(:first-child) {
    padding-top: 5px
}

.notice-content {
    font-size: 14px;
    word-break: break-word;
    font-family: "open sans";
    font-size: 14px;
}
</style>
